export const socialAcquireProcessUpdateFrag = `
    id
`;
